import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, of, switchMap, tap } from 'rxjs';
import { ApiService } from './api.service';
import {
  ReferenceAppServiceModel,
  ReferenceAppServicesDTOModel,
} from '../models/reference-app-service.model';
import { ApiShortListModel } from '../models/api-list.model';
import { TableDataSelectorModel } from '../models/table-data-selector.model';

@Injectable({
  providedIn: 'root',
})
export class ReferenceAppServicesService {
  private appServiceList$ = new BehaviorSubject<ReferenceAppServiceModel[]>([]);

  private appServiceImgList = [
    { id: 2, imgName: 'biotherm', displayImgOnly: false },
    { id: 999, imgName: 'carita-paris', displayImgOnly: true },
    { id: 998, imgName: 'giorgio-armani', displayImgOnly: true },
    { id: 4, imgName: 'helena-rubinstein', displayImgOnly: true },
    { id: 5, imgName: 'kiehl-s', displayImgOnly: true },
    { id: 996, imgName: 'l-oreal-professionnel', displayImgOnly: true },
    { id: 1, imgName: 'lancome-paris', displayImgOnly: false },
    { id: 6, imgName: 'prada', displayImgOnly: true },
    { id: 997, imgName: 'skin-ceuticals', displayImgOnly: true },
    { id: 3, imgName: 'yves-saint-laurent', displayImgOnly: false },
  ];

  constructor(public _apiService: ApiService) {}

  getList(): Observable<ReferenceAppServiceModel[]> {
    return this.appServiceList$.pipe(
      switchMap((appServiceList: ReferenceAppServiceModel[]) =>
        appServiceList.length ? of(appServiceList) : this.fetchListFromApi()
      )
    );
  }

  private fetchListFromApi(): Observable<ReferenceAppServiceModel[]> {
    return this._apiService
      .get<
        ApiShortListModel<ReferenceAppServicesDTOModel>
      >('reference-appservices')
      .pipe(
        map(
          (
            appServicesDTOList: ApiShortListModel<ReferenceAppServicesDTOModel>
          ): Array<ReferenceAppServiceModel> => {
            return appServicesDTOList.value.map(
              (
                appServicesDTOInList: ReferenceAppServicesDTOModel
              ): ReferenceAppServiceModel => {
                const appService: ReferenceAppServiceModel = {
                  id: appServicesDTOInList.id,
                  name: appServicesDTOInList.appName,
                  signatureId: appServicesDTOInList.signatureId,
                  isActive: appServicesDTOInList.isActive,
                };

                const brandGroupImg = this.appServiceImgList.find(
                  appServiceImgInList =>
                    appServiceImgInList.id === appService.id
                );

                if (brandGroupImg) {
                  appService.imgName = brandGroupImg.imgName;
                  appService.displayImgOnly = brandGroupImg.displayImgOnly;
                }

                return appService;
              }
            );
          }
        ),
        tap(appServiceList => this.appServiceList$.next(appServiceList))
      );
  }

  public transformAppServiceListToTableDataList(
    appServiceList: Array<ReferenceAppServiceModel>
  ): Array<TableDataSelectorModel> {
    return appServiceList.map(
      (appService: ReferenceAppServiceModel, index): TableDataSelectorModel =>
        this.transformBrandToTableData(index, appService)
    );
  }

  private transformBrandToTableData(
    index: number,
    appService: ReferenceAppServiceModel
  ): TableDataSelectorModel {
    return {
      position: index,
      id: appService.id.toString(),
      text: appService.name,
    };
  }
}
